import PartyTarget from "../../../model/character/PartyTarget";
import Totals from "../../../model/crew/Totals";
import Statistics from "../../../model/statistics/Statistics";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import TitleView from "./TitleView";
import RowContainerPanel from "./RowContainerPanel";

export default class TopRowContainer extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {Totals} totals
     * @param {PartyTarget} partyTarget
     * @param {Statistics} statistics
     */
    constructor(parentId, elementId, totals, partyTarget, statistics) {
        super(parentId, elementId);

        this.addView(new TitleView(elementId));

        this.addView(new RowContainerPanel(elementId, totals, partyTarget, statistics));

    }

    /**
     * @override
     */
    initializeView() {
        // <div id="topRowContainer" class="top-row">

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'top-row');

        // ////////////////////
        // // Game Title
        // ////////////////////

        // const gameTitleContainer = Page.createElement('div', topRowElement, null, 'game-title-container');
        // const gameTitleBody = Page.createElement('div', gameTitleContainer, null, 'game-title-body');
        // const gameTitleSpan = Page.createElement('div', gameTitleBody, null, 'game-title-display');

        // gameTitleSpan.innerHTML = 'Mining Crew';



        super.initializeView();
    }
}